<template>
  <footer class="homeFooter">
    <div class="authorize full_layout" v-if="isPath">
      <h3 class="allTitle">Officially authorized</h3>
      <img class="authorizeDiv" src="../../static/images/footer_empower.png">
      <!-- <div class="authorizeDiv"></div> -->
      <!-- <ul class="authorizeList">
        <li v-for="(item, index) in authorize" :key='index'><img :src="item" /></li>
      </ul> -->
    </div>
   <!--  daka备案/许可证编号为：沪ICP备2022031093号 -->
    <div class="copytext full_layout">
      <div>
        <h4>COMPANY</h4>
        <div>Cardhobby Germany GmbH</div>
        <div>Telefon: <a href="tel:+49 17643383156">+49 17643383156</a></div>
        <div>E-Mail: <a href="mailto:infode@cardhobby.com">infode@cardhobby.com</a></div>
      </div>
      <div>
        <h4>INFORMATION</h4>
        <div class="shipping_icon">
          <ul>
            <li><a href="/#/shippingagreement">Shipping & Delivery</a></li>
            <li><a href="/#/withdrawalagreement">Withdrawal Policy</a></li>
            <li><a href="/#/about">Contact</a></li>
          </ul>
        </div>
      </div>
      <div>
        <h4>LEGAL INFORMATION</h4>
        <div class="shipping_icon">
          <ul>
            <li><a href="/#/impressumagreement">Impressum</a></li>
            <li><a href="/#/useragreement">Terms of Service</a></li>
            <li><a href="/#/privacyagreement">Privacy Policy</a></li>
            <li><a href="/#/registrationagreement">Registration Agreement</a></li>
            
            <li><a :href="$interface.downloadWord">Withdrawal Form</a></li>
          </ul>
        </div>
      </div>
      <div>
        <h4>SHIPPING</h4>
        <div class="shipping_icon">
          <div>
            <img style="height:20px" src="/static/images/dhl.png" />
          </div>
          <div style="padding:2px 10px">
            <img src="/static/images/ups.png" />
          </div>
        </div>
      </div>
    </div>
    <div class="full_layout follow">
      <div>Follow us</div>
      <a class="icon_follow" href="https://www.instagram.com/miao_collectables?igsh=d3p0OHY0dGI5ZjN3" target="_blank">
        <img src="/static/images/icon/icon_ins.png" />
      </a>
    </div>
  </footer>
</template>
<script>
export default {
  name: 'bottomFooter',
  components: {  },
  data() {
    return {
      year:2023,
      authorize:this.$enumInfo.authorize
    }
  },
  props: {
    isPath: Boolean,
  },
  mounted() {
    var date=new Date();
    var year=date.getFullYear();
    this.year=year;
  },
  created() {
  },
  methods: {
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../static/css/footer.css";

</style>



// WEBPACK FOOTER //
// src/components/footer.vue